import React from 'react';

const TrustedPlatform = () => (
  <section className="trusted-platform">
    <div className="container">
      <h1 className="trusted-heading">
        <span className="bharat-text">India's </span>
        <span className="trusted-text">Top Education Platform </span>
        <span className="bharat-text">for competitive exams:</span>
      </h1>
      <h2 className="platform-text">The One-Stop for all your Preparation</h2>
      <p className="trusted-subtext">
        Join thousands of students achieving their IIT dreams with expert guidance, 
        comprehensive resources, and a supportive community.
      </p>
    </div>
  </section>
);

export default TrustedPlatform;